import { __decorate } from "tslib";
import { Injectable, isDevMode } from "@angular/core";
import { AppControllerService } from "../../app-controller.service";
import { AlertType } from "../models/alert";
import { SharedConstants } from "../constants/shared.constants";
let GlobalErrorHandler = class GlobalErrorHandler {
    appControllerService;
    esriBugExceptions = ["abort(RuntimeError: abort(both async and sync fetching of the wasm failed). Build with -s ASSERTIONS=1 for more info.). Build with -s ASSERTIONS=1 for more info."
    ];
    messagesToIgnore = ["NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'false'. Current value: 'true'.. Find more at https://angular.io/errors/NG0100",
        "NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'false'. Current value: 'true'. Expression location: AppComponent component. Find more at https://angular.io/errors/NG0100",
        "NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: 'false'. Current value: 'true'. Expression location: AppComponent component. Find more at https://angular.dev/errors/NG0100",
        "Cannot set properties of null (setting 'animationInProgress')", "Uncaught (in promise): [AbortError]: Aborted",
        "Cannot destructure property 'ngbCollapse' of 'this._collapse' as it is undefined."
    ];
    // intended to be removed once we have feedback from esri inc
    constructor(appControllerService) {
        this.appControllerService = appControllerService;
    }
    handleError(error) {
        if (error.message && this.messagesToIgnore.includes(error.message)) {
            console.log("A non-fatal error occurred.");
            return;
            // @ts-ignore
        }
        else if (error.rejection && this.messagesToIgnore.includes(error.rejection.message)) {
            console.log("A non-fatal error occurred.");
            return;
            // @ts-ignore
        }
        else if (error.rejection && this.esriBugExceptions.includes(error.rejection.message)) {
            console.log("Please ignore esri error.");
            return;
        }
        else if (error.message === "Value must exist") {
            console.log("Error: Value must exist.");
            return;
            // @ts-ignore
        }
        else if (error.hasOwnProperty("status") && error.status !== 500) {
            this.appControllerService.handleServerErrorMessage("", error, null);
            return;
        }
        if (isDevMode()) {
            console.log(error);
            this.appControllerService.showMessage(error.message, AlertType.Error, false);
        }
        else {
            // TODO Dylan post error to server ?
            console.log(error);
            this.appControllerService.showMessage(SharedConstants.GLOBAL_ERROR_MESSAGE, AlertType.Error, false);
        }
    }
    static ctorParameters = () => [
        { type: AppControllerService }
    ];
};
GlobalErrorHandler = __decorate([
    Injectable()
], GlobalErrorHandler);
export { GlobalErrorHandler };
